export default __webpack_public_path__ + "static/media/placeholder_business02-jp-mobile.9a556240.png";